import { Component, OnInit } from '@angular/core';
import { Proveedor } from 'src/app/interfaces/proveedor.interface';
import { VentaService } from 'src/app/services/venta.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Salida } from 'src/app/interfaces/salida.interface';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-egresos',
  templateUrl: './egresos.component.html',
  styleUrls: ['./egresos.component.css']
})
export class EgresosComponent implements OnInit {
  provForm = this.fb.group({
    proveedor: ['', Validators.required],
    monto: ['', [Validators.required, Validators.min(1)]]
  });

  proveedores: Observable<any>;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public ventaService: VentaService
  ) { }

  ngOnInit(): void {
    this.obtenerProveedores();
  }

  obtenerProveedores() {
    this.proveedores = this.ventaService.obtenerProveedores();
  }

  cuadroProveedor(proveedor: Proveedor) {
    this.provForm.controls.proveedor.setValue(proveedor);
    $('#modalEgresos').modal({ keyboard: false });
  }

  agregarDigito(numero: string) {
    let cantidad: string = this.provForm.controls.monto.value;
    if (!cantidad) {
      cantidad = numero
    } else {
      cantidad = cantidad + numero;
    }
    this.provForm.controls.monto.setValue(Number.parseInt(cantidad, 10));
  }

  borrarDigito() {
    let cantidad: string = this.provForm.controls.monto.value.toString();
    if (!cantidad) {
      return;
    }

    if (cantidad.length === 1) {
      this.provForm.controls.monto.setValue('');
      return;
    }

    const ultIndex = cantidad.length - 1;
    cantidad = cantidad.substring(0, ultIndex);

    this.provForm.controls.monto.setValue(cantidad);
  }

  async guardarEgreso() {
    if (this.provForm.invalid) {
      return;
    }

    const salida: Salida = this.provForm.value;
    this.ventaService.caja.salidas.push(salida);

    try {
      $('#modalEgresos').modal('hide');
      await this.ventaService.actualizarSalida();
      this.router.navigateByUrl('/venta');
    } catch (error) {
      console.log(error);
    }

  }

}
